export default {
  sessionInfo: {},
  user: {},
}
